export default {
  sessionInfo: {},
  user: {},
}
